import axios from 'axios'

export const verify = async (apiKey) => {

  const headers = {
    'x-api-key': apiKey
  }

  let response
  try {
    response = await axios.get(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/apikey`, { headers })
  } catch (e) {
    return false
  }

  if(response.status === 200) return true
  else return false
}

export const fetchStatus = async ({apiKey, entryId, environmentId, spaceId}) => {
  const headers = {
    'x-api-key': apiKey
  }

  let response
  try {
    response = await axios.get(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/status?spaceId=${spaceId}&environmentId=${environmentId}&entryId=${entryId}`, {headers})
  } catch (e) {
    console.error(e.response.data)
    return null
  }

  return response.data
}

export const fetchServiceTypes = async ({apiKey, spaceId}) => {
  const headers = {
    'x-api-key': apiKey
  }

  let response = await axios.get(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/service-types?spaceId=${spaceId}`, {headers})

  return response.data
}

export const sendTranslationOrderHuman = async ({apiKey, entryId, environmentId, spaceId, source, targets, serviceType, instructions, sender}) => {

  const headers = {
    'x-api-key': apiKey
  }

  const payload = {
    entryId,
    environmentId,
    spaceId,
    source,
    targets,
    serviceType,
    instructions,
    sender
  }

  let response = await axios.post(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/translate`, payload, { headers })

  return response.data
}

export const sendTranslationOrderMachine = async ({apiKey, entryId, environmentId, spaceId, source, targets, serviceType, style, context, sender}) => {

  const headers = {
    'x-api-key': apiKey
  }

  const payload = {
    entryId,
    environmentId,
    spaceId,
    source,
    targets,
    serviceType,
    style,
    context: context ? context.split('\n') : undefined,
    sender
  }

  let response = await axios.post(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/translate/ai`, payload, { headers })

  return response.data
}

export const cancelOrders = async ({apiKey, orders}) => {
  const headers = {
    'x-api-key': apiKey
  }

  let response = await axios.post(`${process.env.REACT_APP_CONNECTOR_URL}/v1/contentful/cancel`, { orders }, { headers })

  return response.data
}